// extracted by mini-css-extract-plugin
module.exports = {"text1Line":"styles_text1Line__xzyEH","ellipsis":"styles_ellipsis___pKF1","text2AndMoreLines":"styles_text2AndMoreLines__hHH_q","tooltipTrigger":"styles_tooltipTrigger__6bcY_"};